import { Divider, Row, Typography } from 'antd';
import React, { memo } from 'react';

const { Title } = Typography;

interface IAdjustment {
  name: string;
  imageName: string;
  remark: string;
  unit: string;
  value: string;
  subAdjustments: IAdjustment[];
}

interface IProps {
  adjustment: IAdjustment;
}

export const Adjustment: React.FC<IProps> = memo(({ adjustment }) => {
  return (
    <>
      {adjustment && (
        <>
          <Row>
            <Title level={4}>
              {adjustment.name} {adjustment.remark} {adjustment.value} {adjustment.unit}
            </Title>
          </Row>
          {adjustment.imageName && (
            <Row>
              <img alt="" width={600} src={adjustment.imageName} />
            </Row>
          )}
          {adjustment.subAdjustments?.map((subAdjustment, index) => {
            return (
              <Row key={`${subAdjustment.name}${index}`}>
                <Title level={5}>
                  {subAdjustment.name} {subAdjustment.remark} {subAdjustment.value}
                  {subAdjustment.unit}
                </Title>
                {subAdjustment.imageName && (
                  <img alt="" width={600} src={subAdjustment.imageName} />
                )}
              </Row>
            );
          })}
          <Divider />
        </>
      )}
    </>
  );
});
